/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindProductBrandValuesQueryResponse,
  FindProductBrandValuesQueryParams,
} from "../types/FindProductBrandValues.ts"

export const findProductBrandValuesQueryKey = (
  params?: FindProductBrandValuesQueryParams
) =>
  [
    { url: "/v1/product/find-product-brand-values" },
    ...(params ? [params] : []),
  ] as const

export type FindProductBrandValuesQueryKey = ReturnType<
  typeof findProductBrandValuesQueryKey
>

/**
 * @summary Find product brand values
 * {@link /v1/product/find-product-brand-values}
 */
export async function findProductBrandValues(
  params?: FindProductBrandValuesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductBrandValuesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-product-brand-values`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductBrandValuesQueryOptions(
  params?: FindProductBrandValuesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findProductBrandValuesQueryKey(params)
  return queryOptions<
    ResponseConfig<FindProductBrandValuesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductBrandValuesQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findProductBrandValues(params, config)
    },
  })
}

/**
 * @summary Find product brand values
 * {@link /v1/product/find-product-brand-values}
 */
export function useFindProductBrandValues<
  TData = ResponseConfig<FindProductBrandValuesQueryResponse>,
  TQueryData = ResponseConfig<FindProductBrandValuesQueryResponse>,
  TQueryKey extends QueryKey = FindProductBrandValuesQueryKey,
>(
  params?: FindProductBrandValuesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductBrandValuesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ?? findProductBrandValuesQueryKey(params)

  const query = useQuery(
    {
      ...findProductBrandValuesQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
